export default __webpack_public_path__ + "static/media/demo2.b2fe9293.gif";